import Avatar from "@mui/material/Avatar";
import type { AvatarProps } from "@mui/material/Avatar";

import { getGrapeColorFromName } from "@/utils/get-grape-color-from-name";
import { toProperCase } from "@/utils/to-proper-case";

interface VarietalAvatarProps extends AvatarProps {
    varietal: string;
}

export default function VarietalAvatar({ varietal, style, ...passedProps }: VarietalAvatarProps) {
    varietal = toProperCase((varietal || "Na").trim());
    let titleText = varietal;
    let twoLetterCode = "Na";
    if (varietal.includes(" ")) {
        twoLetterCode = `${varietal.split(" ")[0][0]}${varietal.split(" ")[1][0]}`;
    } else {
        twoLetterCode = `${varietal[0]}${varietal[1]}`;
    }
    let varietalColor = getGrapeColorFromName(varietal);
    if (varietal === "Na") {
        varietalColor = null;
        titleText = "varietal not specified";
    }
    style = {
        backgroundColor: varietalColor,
        ...(style || {}),
    };

    return (
        <Avatar style={style} {...passedProps} title={titleText}>
            {twoLetterCode}
        </Avatar>
    );
}
